var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":""},on:{"click":_vm.clickAction}},[_c('p',[_c('v-icon',[_vm._v("mdi-chevron-up-circle-outline")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }